import React from "react";
import * as styles from "./InlineCTABox.module.scss";
import clsx from "clsx";
import { ButtonsContainer } from "@silversea-ssc/ui-components-react";

interface InlineCTABoxProps {
  className?: string;
  align?: "center" | "right" | "left";
  spacingTop?: "compact" | "regular" | false;
  spacingBottom?: "compact" | "regular" | false;
  dataContentName: string;
}

export const InlineCTABoxButton: React.FC<React.PropsWithChildren<unknown>> = (
  props
) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export const InlineCTABoxButtons: React.FC<React.PropsWithChildren<unknown>> = (
  props
) => {
  return (
    <div className={styles.buttonsContainer}>
      <ButtonsContainer mobileFullSize align="right">
        {props.children}
      </ButtonsContainer>
    </div>
  );
};

export const InlineCTABoxContent: React.FC<React.PropsWithChildren<unknown>> = (
  props
) => {
  return <div className={styles.content}>{props.children}</div>;
};

const InlineCTABox: React.FC<React.PropsWithChildren<InlineCTABoxProps>> = ({
  className = undefined,
  align = "center",
  children,
  spacingTop = "compact",
  spacingBottom = "compact",
  dataContentName
}) => {
  return (
    <div
      data-content-name={dataContentName}
      className={clsx(styles.inlineCtaBox, className, {
        [styles.alignLeft]: align == "left",
        [styles.alignCenter]: align == "center",
        [styles.alignRight]: align == "right",
        [styles.spacingTopCompact]: spacingTop == "compact",
        [styles.spacingTopRegular]: spacingTop == "regular",
        [styles.spacingBottomCompact]: spacingBottom == "compact",
        [styles.spacingBottomRegular]: spacingBottom == "regular"
      })}
    >
      {children}
    </div>
  );
};

export default InlineCTABox;
